(() => {
  'use strict';
  if (window.__zaftUpcartSyncInstalled) return;
  window.__zaftUpcartSyncInstalled = true;
  let pending = false;
  let timer = null;
  let readinessAttempts = 0;
  let issuing = false;
  let vendorReady = false;
  let unreadyApi = null;
  const cartIsMounted = () => Boolean(
    document.getElementById('upCart')?.shadowRoot?.querySelector('#CartPopup') ||
    document.querySelector('#UpcartPopup #CartPopup')
  );
  const attemptRefresh = () => {
    timer = null;
    if (!pending) return;
    const refresh = window.upcartRefreshCart;
    const mounted = cartIsMounted();
    if (!vendorReady && !mounted) unreadyApi = refresh;
    if (typeof refresh !== 'function' ||
        (!vendorReady && (!mounted || refresh === unreadyApi))) {
      if (readinessAttempts++ < 40) timer = setTimeout(attemptRefresh, 250);
      return;
    }
    pending = false;
    issuing = true;
    try {
      const result = window.upcartRefreshCart();
      if (result && typeof result.catch === 'function') {
        result.catch(() => { pending = true; });
      }
    } catch (_) {
      pending = true;
    } finally {
      issuing = false;
    }
  };
  const requestSync = () => {
    if (issuing) return;
    pending = true;
    if (!vendorReady && !cartIsMounted()) unreadyApi = window.upcartRefreshCart;
    readinessAttempts = 0;
    clearTimeout(timer);
    timer = setTimeout(attemptRefresh, 80);
  };
  const onThemeChange = event => {
    if (event.detail?.source === 'zaft-theme') requestSync();
  };
  const resumePending = () => {
    if (!pending || timer) return;
    readinessAttempts = 0;
    timer = setTimeout(attemptRefresh, 100);
  };
  document.addEventListener('cart:updated', onThemeChange);
  document.addEventListener('cart:build', onThemeChange);
  document.addEventListener('zaft:cart-sync-request', requestSync);
  document.addEventListener('click', resumePending, true);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) resumePending();
  });
  window.addEventListener('aftersell-upcart:public-events:cart-loaded', () => {
    vendorReady = true;
    resumePending();
  });
  window.addEventListener('load', resumePending);
})();
